// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"a5156e9c","122":"f2ae91fa"}[chunkId] + ".chunk.css";
};